import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type { BaseFormArgs } from 'ember-form-changeset-validations/components/form';
import BaseForm from 'ember-form-changeset-validations/components/form';
import type { ContactDTO } from 'frontend/services/contact';
import type ContactService from 'frontend/services/contact';
import { tracked } from 'tracked-built-ins';

interface FormsContactArgs extends BaseFormArgs<ContactDTO> {}

export default class FormsContact extends BaseForm<
  FormsContactArgs,
  ContactDTO
> {
  @tracked declare subject: string;
  @service declare contact: ContactService;
  @service declare router: RouterService;

  constructor(owner: unknown, args: FormsContactArgs) {
    super(owner, args);
  }
  @action
  select(field: keyof ContactDTO, value: unknown) {
    this.args.changeset.set(field, value);
  }
}
